export const GOALS_REFLECTION_PROMPT =
  'Looking at your goals, what helped you make progress, and what’s getting in the way?';

export const isGoalsReflectionQuestion = (question?: string | null) =>
  question?.trim() === GOALS_REFLECTION_PROMPT;
